import StringUtil from "@/plugins/string-util/StringUtil";

/**
 * VueにプラグインとしてStringUtilインスタンスを持たせる
 */
export default {
  install(Vue: any, options: any) {
    Vue.prototype.$stringUtil = new StringUtil();
  }
};

/**
 * Vueの型定義にStringUtilを追加する
 */
declare module "vue/types/vue" {
  interface Vue {
    $stringUtil: StringUtil;
  }
  interface VueConstructor {
    $stringUtil: StringUtil;
  }
}
